import config from "../configs/index";
const { BASE_URL, SLEEK_URL } = config[process.env.REACT_APP_ENVIRONMENT]

// get all company details
export const GET_COMPANY_DETAILS = `${BASE_URL}/api/company/`;

export const POST_TOKEN = `${BASE_URL}/api/connect`;

export const MAILROOM = `${SLEEK_URL}/admin/mailroom/`;
